module.exports = __webpack_public_path__ + "img/reliable.fbca4f41.svg";